import { useQuery } from "@tanstack/react-query";
import { Api } from "../openApi";

export type ForeignCurrencyInsuranceRankProps = {
  age: number;
  sex: number;
  intentionRecommendInsurance: boolean;
  baseCode?: string;
  onSuccess?: () => void;
};

export const useForeignCurrencyInsuranceRank = (params: ForeignCurrencyInsuranceRankProps) => {

  return useQuery(
    ["getForeignCurrencyInsuranceRank", params],
    async () => {
      const { data } = await Api.getApiForeignCurrencyInsurancesRank(
        params.age,
        params.sex,
        params.intentionRecommendInsurance,
        params.baseCode
      );
      params.onSuccess && params.onSuccess();
      return data;
    },
    { enabled: false }
  );
};
